module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-top": "2.5em"
    }
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("PUBLISHER:")]), _vm._v(" Amy Marson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("CREATIVE DIRECTOR:")]), _vm._v(" Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("PROJECT EDITOR:")]), _vm._v(" Alice Mace Nakanishi")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("DEVELOPMENTAL EDITORS:")]), _vm._v(" Jenifer Dick, Edie McGinnis, Kimber Mitchell, and Deb Rowden")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("TECHNICAL EDITORS:")]), _vm._v(" Mary Atherton, Christina DeArmond, Kathe Dougherty, and Jane Miller")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("COVER/BOOK DESIGNER:")]), _vm._v(" April Mostek")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("PRODUCTION COORDINATORS:")]), _vm._v(" Joe Edge and Zinnia Heinzmann")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("PRODUCTION ASSISTANT:")]), _vm._v(" Jeanie German")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("ILLUSTRATORS:")]), _vm._v(" Lon Eric Craven and Eric Sears")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "sa"
  }, [_vm._v("PHOTOGRAPHY BY")]), _vm._v(" Aaron T. Leimkuehler and Natalie Turley")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Published by C&T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8673887c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 60
// module chunks = 0